var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9303 0.931519H22.547C21.7402 0.931519 21.0861 1.42705 21.0861 2.03831V21.9617C21.0861 22.5729 21.7402 23.0685 22.547 23.0685H26.9303C27.7372 23.0685 28.3913 22.5729 28.3913 21.9617V2.03831C28.3913 1.42705 27.7372 0.931519 26.9303 0.931519Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7027 9.23279H12.3195C11.5126 9.23279 10.8585 9.72832 10.8585 10.3396V21.9616C10.8585 22.5729 11.5126 23.0684 12.3195 23.0684H16.7027C17.5096 23.0684 18.1637 22.5729 18.1637 21.9616V10.3396C18.1637 9.72832 17.5096 9.23279 16.7027 9.23279Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47521 16.9807H2.09195C1.28508 16.9807 0.630981 17.4762 0.630981 18.0875V21.9617C0.630981 22.573 1.28508 23.0685 2.09195 23.0685H6.47521C7.28208 23.0685 7.93618 22.573 7.93618 21.9617V18.0875C7.93618 17.4762 7.28208 16.9807 6.47521 16.9807Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.843912f9ecf5bb78e65e2b64af165f89.svg";
export { ForwardRef as ReactComponent };